// Pure helper for the disposition window's option loads (doc 22 Part A).
// Extracted (no axios import) so the resilience behavior is unit-testable under
// CRA jest — see batchPlanLogic.ts / bankAging.ts for the same pattern.

// One settled result from a `dapi.matching*` call (an axios-style {data}).
export type SettledLoad<T = any> = PromiseSettledResult<{ data: T[] }>;

// Fulfilled -> its data; rejected -> [] (so one failing endpoint can't blank the
// others). Null/undefined data is also normalized to [].
export function pickSettled<T = any>(result: SettledLoad<T>): T[] {
  if (result.status === 'fulfilled') {
    return result.value?.data ?? [];
  }
  return [];
}
